module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCwwIDI1LDE1Ij4KCTxyZWN0IHdpZHRoPSIyNSIgaGVpZ2h0PSIxNSIgZmlsbD0iIzAwMjQ3ZCIvPgoJPHBhdGggZD0iTSAwLDAgTCAyNSwxNSBNIDI1LDAgTCAwLDE1IiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMyIvPgoJPHBhdGggZD0iTSAxMi41LDAgViAxNSBNIDAsNy41IEggMjUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSI1Ii8+Cgk8cGF0aCBkPSJNIDEyLjUsMCBWIDE1IE0gMCw3LjUgSCAyNSIgc3Ryb2tlPSIjY2YxNDJiIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/unitedkingdom.svg
// module id = nXfz
// module chunks = 1